import DataTable from "../component/applications/DataTable";
import FullCalender from "../component/applications/FullCalender";
import Kanban from "../component/applications/Kanban";
import Wizard from "../component/applications/Wizard";
import Invoice from "../component/pages/account/Invoice";
import Settings from "../component/pages/account/Settings";
import Alerts from "../component/pages/Alerts";
import Billing from "../component/pages/Billing";
import ChartLine from "../component/pages/ChartLine";
import CRM from "../component/pages/CRM";
import OrderDetails from "../component/pages/ecommerce/order/OrderDetails";
import OrderList from "../component/pages/ecommerce/order/OrderList";
import EditProduct from "../component/pages/ecommerce/Products/EditProduct";
import NewProduct from "../component/pages/ecommerce/Products/NewProduct";
import ProductPage from "../component/pages/ecommerce/Products/ProductPage";
import Groups from "../component/pages/groups";
import Home from "../component/pages/Home";
import Notifications from "../component/pages/Notifications";
import Profile from "../component/pages/Profile";
import AllProject from "../component/pages/profile/AllProject";
import TimeLine from "../component/pages/projects/TimeLine";
import Rtl from "../component/pages/Rtl";
import NewUsers from "../component/pages/users/NewUsers";
import PhysicianPage from "../component/pages/physician_page/PhysicianPage";

import VideoLibraryPage from "../component/pages/admin/videos/VideoLibraryPage";

import SupportPage from "../component/pages/support_page/SupportPage";
import VideosPage from "../component/pages/videos_page/VideosPage";
import AuthGuard from "./AuthGuard";
import LibraryManagerPage from "../component/pages/library_manager/LibraryManagerPage";
import PatientsPage from "../component/pages/patients_page/PatientsPage";
import PricingPage from "../component/pages/pricing_page/PricingPage";
import ScriptLibraryPage from "../component/pages/admin/scripts/ScriptLibraryPage";
import MySubscription from "../component/pages/my_subscription/MySubscription";
import MyProfilePage from "../component/pages/myprofile/MyProfilePage";
import CCMCoordinatorPage from "../component/pages/ccm_manager_page/CCMCoordinatorPage";
import JourneyPage from "../component/pages/journeys/JourneyPage";
import JourneyPreviewPage from "../component/pages/journeys/JourneyPreviewPage";
import JourneyDetailPage from "../component/pages/journeys/JourneyDetailPage";
import Analytics from "../component/pages/analytics/AnalyticsPage";
import Calendar from "../component/pages/calendar/CalendarPage";


const routes = [
  {
    path: "/pages/calendar",
    exact: true,
    name: "Calendar",
    component: Calendar,
  },
  {
    path: "/pages/analytics",
    exact: true,
    name: "Analytics",
    component: Analytics,
  },
  {
    path: "/pages/library-manager",
    exact: true,
    name: "Library Manager",
    component: LibraryManagerPage,
  },
  {
    path: "/pages/groups",
    exact: true,
    name: "Groups",
    component: Groups,
  },
  {
    path: "/dashboard",
    exact: true,
    name: "Default",
    component: Home,
    // component: (props) => (
    //   <AuthGuard
    //     roles={["Owner"]}
    //   >
    //     <Home {...props} />
    //   </AuthGuard>
    // ),
  },
  {
    path: "/pages/journeys",
    exact: true,
    name: "Journeys",
    component: JourneyPage,
  },
  {
    path: "/pages/journeys/details/:id",
    exact: true,
    name: "Journey Details",
    component: JourneyDetailPage,
  },
  {
    path: "/pages/journeys/preview/:id",
    exact: true,
    name: "Journey Preview",
    component: JourneyPreviewPage,
  },
  {
    path: "/video-library",
    exact: true,
    name: "Video Library",
    component: VideoLibraryPage,
  },
  {
    path: "/script-library",
    exact: true,
    name: "Script Library",
    component: ScriptLibraryPage,
  },
  {
    path: "/pages/patients",
    exact: true,
    name: "Patients",
    component: PatientsPage,
  },
  {
    path: "/pages/my-subscriptions",
    exact: true,
    name: "Subscriptions",
    component: MySubscription,
  },
  {
    path: "/my-profile",
    exact: true,
    name: "My Profile",
    component: MyProfilePage,
  },
  // {
  //   path: "/pages/pricing-page",
  //   exact: true,
  //   name: "Pricing",
  //   component: PricingPage,
  // },
  {
    path: "/dashboard/crm",
    exact: true,
    name: "CRM",
    component: CRM,
  },
  {
    path: "/pages/profile/profile-overview",
    exact: true,
    name: "Profile Overview",
    component: Profile,
  },
  {
    path: "/pages/profile/all-projects",
    exact: true,
    name: "All Project",
    component: AllProject,
  },
  {
    path: "/pages/users/new-user",
    exact: true,
    name: "New User",
    component: NewUsers,
  },
  {
    path: "/pages/account/settings",
    exact: true,
    name: "Settings",
    component: Settings,
  },
  {
    path: "/pages/account/billing",
    exact: true,
    name: "Billing",
    component: Billing,
  },
  {
    path: "/pages/account/invoice",
    exact: true,
    name: "Invoice",
    component: Invoice,
  },
  {
    path: "/pages/projects/timeline",
    exact: true,
    name: "Timeline",
    component: TimeLine,
  },
  {
    path: "/pages/rtl",
    exact: true,
    name: "RTL",
    component: Rtl,
  },
  {
    path: "/pages/charts",
    exact: true,
    name: "Charts",
    component: ChartLine,
  },
  {
    path: "/pages/alerts",
    exact: true,
    name: "Alerts",
    component: Alerts,
  },
  {
    path: "/pages/notifications",
    exact: true,
    name: "Notification",
    component: Notifications,
  },
  {
    path: "/applications/kanban",
    exact: true,
    name: "Kanban",
    component: Kanban,
  },
  {
    path: "/applications/wizard",
    exact: true,
    name: "Wizard",
    component: Wizard,
  },
  {
    path: "/applications/data-table",
    exact: true,
    name: "DataTable",
    component: DataTable,
  },
  {
    path: "/applications/calendar",
    exact: true,
    name: "Calender",
    component: FullCalender,
  },
  {
    path: "/ecommerce/products/new-product",
    exact: true,
    name: "New Product",
    component: NewProduct,
  },
  {
    path: "/ecommerce/products/edit-product",
    exact: true,
    name: "Edit Product",
    component: EditProduct,
  },
  {
    path: "/ecommerce/products/product-page",
    exact: true,
    name: "Product Page",
    component: ProductPage,
  },
  {
    path: "/ecommerce/orders/order-list",
    exact: true,
    name: "Order List",
    component: OrderList,
  },
  {
    path: "/ecommerce/orders/order-details",
    exact: true,
    name: "Order List",
    component: OrderDetails,
  },
  {
    path: "/pages/physicians",
    exact: true,
    name: "Physician",
    component: PhysicianPage,
  },
  {
    path: "/pages/support",
    exact: true,
    name: "Support",
    component: SupportPage,
  },
  {
    path: "/pages/videos",
    exact: true,
    name: "Videos Library",
    component: VideosPage,

  },
  {
    path: "/pages/ccm-coordinator",
    exact: true,
    name: "CCM Coordinator",
    component: CCMCoordinatorPage,
  }
];

export default routes;
